import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DriverForm, driverSchema } from 'components/Drivers/DriverForm'
import { UserAccountSchema } from 'components/Users/validationSchema'
import { SuccessDialog } from 'components/Shared/Dialogs/SuccessDialog'
import { triggerFormSubmit } from 'utils/utils'
import { TitleBar } from 'components/Shared/CrudComponents/TitleBar'
import { USERNAME_CONFLICT } from 'services/errorCodes'
import { createDriver } from 'services'
import { HTTP_422_ERROR } from 'Constants'
import ApiError from 'constants/ApiError'
import { useErrorHandling } from 'context/errorHandling'
import { useNavigatePrevent } from 'context/navigatePrevent'
import { FormikForm } from 'components/Shared/FormikForm'
import Module from 'constants/customFieldModules'

const initialValues = {
  firstName: '',
  lastName: '',
  address: '',
  phoneNumber: '',
  personalPhoneNumber: '',
  idCardNumber: '',
  idCardExpirationDate: null,
  driverLicenseNumber: '',
  driverLicenseCategory: '',
  driverLicenseExpirationDate: null,
  adrCertificateNumber: '',
  adrCertificateExpirationDate: null,
  username: '',
  password: '',
  passwordConfirmation: '',
  filesIds: []
}

export function CreateDriverForm () {
  const [createdDialogOpen, setCreatedDialogOpen] = useState(false)

  const { handleError } = useErrorHandling()

  const { t } = useTranslation()

  const createDriverFormRef = useRef()

  const { setNavigationUnlocked } = useNavigatePrevent()

  function handleSubmit (values, onSuccess) {
    createDriver({
      ...values,
    }).then(createdDriver => onSuccess(createdDriver.id)
      .then(() => setCreatedDialogOpen(true))
      .catch(handleError)
    ).catch(error => handleError(error, {
      [HTTP_422_ERROR]: error?.response?.data?.errorCode === USERNAME_CONFLICT ?
        'notifications.error.usernameConflict' : ApiError.UnprocessableEntity
    }))
  }

  return <div>
    <TitleBar
      buttonLabel={t('form.driver.submit')}
      onButtonClick={triggerFormSubmit(createDriverFormRef)}
      title={t('form.driver.createDriverTitle')}/>
    <SuccessDialog open={createdDialogOpen}
                   onClose={() => {
                     setCreatedDialogOpen(false)
                     setNavigationUnlocked(history => history.push('/drivers'))
                   }} content={t('notifications.success.createdDriver')}/>
    <FormikForm
      innerRef={createDriverFormRef}
      initialValues={initialValues}
      validationSchema={driverSchema.concat(UserAccountSchema)}
      onSubmit={handleSubmit}
      customFields={{
        module: Module.Drivers
      }}>
      <DriverForm
        initialFiles={[]}
        createForm/>
    </FormikForm>
  </div>
}
